// components/ChipSelect.jsx

import React from "react";
import styles from "./Chipselect.module.css";

/**
 * ChipSelect — reusable pill selector
 * @param {Array}     options
 * @param {string}    value
 * @param {function}  onChange
 * @param {function}  onAdvance
 * @param {boolean}   showIcons
 */
const ChipSelect = ({
  options = [],
  value,
  onChange,
  onAdvance,
  showIcons
}) => {
  const handleClick = (opt) => {
    onChange(opt);
    if (onAdvance) {
      setTimeout(() => onAdvance(), 280);
    }
  };

  return (
    <div className={styles.chipGrid}>
      {options.map((option) => {
        const optionValue = option.value || option;
        const optionLabel = option.label || option;

        return (
          <button
            key={optionValue}
            className={`${styles.chip} ava-text-body ${
              value === optionValue ? styles.chipActive : ""
            }`}
            onClick={() => handleClick(optionValue)}
            type="button"
          >
            {showIcons && option.icon && (
              <img
                src={option.icon}
                alt=""
                className={styles.chipIcon}
              />
            )}
            <span>{optionLabel}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ChipSelect;